import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
const ExtraProjects = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="popular-projects">
      <div className="popular-project-head-div">
        <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/Kxj7t31/Screenshot-213.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Travel BD</h3>
            <div data-aos="slide-up">
              <p>
                Travel Bd is traveler blog related website.
              </p>
              <p>
                Happy is online resort booking website with offering best price.
              </p>
              <p>Implement CRUD operation and using MERN.</p>
              <p>This site all device responsive</p>
            </div>
            <Link className="aboutMe-button" to="/HappyHolidayTourism">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://haapy-holiday.web.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>

        <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/2qy8KRG/Screenshot-26-1.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Happy Holiday Tourism</h3>
            <div data-aos="slide-up">
              <p>
                User can book their selected tour package and vew their order
                detail on My Order page.
              </p>
              <p>
                Happy is online resort booking website with offering best price.
              </p>
              <p>Implement CRUD operation and using MERN.</p>
              <p>This site all device responsive</p>
            </div>
            <Link className="aboutMe-button" to="/HappyHolidayTourism">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://haapy-holiday.web.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>

        <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            {" "}
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/zVrfF5H/Screenshot-27.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            {" "}
            <h3 data-aos="slide-down">The Medic Nucleus</h3>
            <div data-aos="slide-up">
              <p>
                This is medical services related website and all device
                responsive.
              </p>
              <p>
                Madic Nucleus Provided free treatment for Autistic children and
                poor family,Medic_Nucleus team move to workshop every month.
              </p>

              <p>Implement firebase Authentication System.</p>
              <p>
                Using technologies are ReactJS, ReactBootstrap, Firebase,
                Netlify.
              </p>
            </div>
            <Link className="aboutMe-button" to="/MedicNucleus">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://medic-nucleus.netlify.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>
        <div data-aos="flip-left" className="row  com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/6mtHJC2/motorbike-Training-1.png"
              alt=""
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Motor Bike Training Club</h3>
            <div data-aos="slide-up">
              <p>
                Motorbike Training Club provide best teacher for improve your
                skill.
              </p>
              <p>
                Using technologies are ReactJS, React Bootstrap, React Router ,
                Netlify.
              </p>
              <p>MotorBike Training Club ceate world class motor bike rider.</p>
              <p>
                This Site fully responsive for all devices, and fully Functional
                site.
              </p>
            </div>
            <Link className="aboutMe-button" to="/MotorBikeTrainingClub">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://motorbike-training-club.netlify.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>

        {/* <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/S0s9FKJ/bd-Musician.png"
              alt=""
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Rock Band4</h3>
            <div data-aos="slide-up">
              <p>
                Roack Band4 is a international concert organized with
                international standard musician like James, ayub Bacchu, Shafin.
              </p>
              <p>
                Bangladesh has legends and international standard singer so we
                will highlighting our singers.
              </p>

              <p>
                This site all device responsive and usung simple react, and has
                simple functionalities{" "}
              </p>
            </div>
            <Link className="aboutMe-button" to="/RockBand">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://band-musicians-bd.netlify.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div> */}

        <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            {" "}
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/1MnLYmX/foodSite.png"
              alt=""
            />
          </div>

          <div className="col-md-6 com-b">
            {" "}
            <h3 data-aos="slide-down">FoodSite</h3>
            <div data-aos="slide-up">
              <p>
                This is a food related website, search by name.
              </p>
              <p>
                Make Single Page Application with reactJS. 
              </p>

              <p>Using Rest api for get data, Makes all device responsive for ui</p>
              
              <p>
                Using technologies are ReactJS, ReactBootstrap,
                Netlify.
              </p>
            </div>
            <Link className="aboutMe-button" to="/projects/FoodSite">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://restaurant-react-routing-spa.netlify.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraProjects;
